@if (dynamicPropertySpecs$ | async; as specs) {
  <elder-basic-pane-layout class="full p-0">
    <!-- p-0 for nested panes -->
    <elder-pane class="flex-25">
      <!-- Dynamic Property Specs -->
      <elder-pane-subtitle>{{ 'properties.dynamic.title' | translate }}</elder-pane-subtitle>
      <elder-table
        class="flex"
        [data]="dynamicPropertySpecs$ | async"
        [elderTableActivation]="{}"
        [activeItem]="selectedSpec$ | async"
        (activeItemChange)="onSpecSelected($event)"
        [selectionMultiEnabled]="true"
        [selectionVisible]="true"
      >
        <elder-data-toolbar
          *elderTableToolbar
          [canMore]="false"
          [canAdd]="true"
          [canRemove]="true"
          (requestNew)="onNewSpec($event)"
          (requestRemove)="onRemoveSpecs($event)"
        >
        </elder-data-toolbar>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{ 'context.name' | translate }}</th>
          <td mat-cell *matCellDef="let spec">{{ spec.name }}</td>
        </ng-container>
        <ng-container matColumnDef="conditions">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'skillSets.conditions.title' | translate }}
          </th>
          <td mat-cell *matCellDef="let spec">{{ spec.conditions?.length }}</td>
        </ng-container>
        <ng-container matColumnDef="properties">
          <th mat-header-cell *matHeaderCellDef>{{ 'properties.title' | translate }}</th>
          <td mat-cell *matCellDef="let spec">{{ spec.properties?.length }}</td>
        </ng-container>
      </elder-table>
    </elder-pane>
    <elder-pane>
      <app-dynamic-property-spec-detail
        class="flex"
        [propertyKinds]="propertyKinds"
        [spec]="selectedSpec$ | async"
      >
      </app-dynamic-property-spec-detail>
    </elder-pane>
  </elder-basic-pane-layout>
}
